<div #wallboardViewSlide class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }">
    <div class="FlexRowNoWrap" [ngClass]="hasBackdrop ? 'wallboardViewSlideContentAreaDark' : 'wallboardViewSlideContentAreaLight'">
        <div class="spotlightDataColumn">
            <div class="spotlightTitleName txtOverflow">{{spotlightState?.LoginName}}</div>

            <div class="spotlightDataBox FlexColNoWrap dataBox" [attr.mid]="moduleKey">
                <div class="h-100" style="overflow:hidden" *ngIf="showType == 1">
                    <div class="spotlightBioText profileBio" [attr.mid]="moduleKey" *ngIf="spotlightState?.UseProfileBio" style="white-space:pre-wrap">{{getBioText(true)}}</div>
                    <div class="spotlightBioText otherBio" [attr.mid]="moduleKey" *ngIf="!spotlightState?.UseProfileBio" style="white-space:pre-wrap">{{getBioText(false)}}</div>
                </div>

                <div class="h-100" *ngIf="showType == 2">
                    <div class="spotlightHobbyHeader hobbyHeading" [attr.mid]="moduleKey">{{hobbiesLabel}}</div>
                    <div class="spotlightHobbyHolder hobbyTable" [attr.mid]="moduleKey">
                        <li class="spotlightHobbyItem {{'hobbyItem' + i}}" *ngFor="let item of spotlightState?.HobbyList; let i = index">{{item}}</li> 
                    </div>  
                </div>

                <div class="FlexColNoWrap badgeContainer h-100" [attr.mid]="moduleKey" *ngIf="showType == 3">
                    <div class="SpotlightInfoBadgeTitle badgeHeading" [attr.mid]="moduleKey">{{badgesLabel}}</div>

                    <div class="FlexRowNoWrap SpotlightInfoBadgeHolder badgeHolder" [attr.mid]="moduleKey">
                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem1">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(1)" *ngIf="spotlightState?.ShowBadgeCount == 1 || spotlightState?.ShowBadgeCount == 3 || spotlightState?.ShowBadgeCount == 6" />
                            <div [ngClass]="{ SpotlightInfoBadgeLabelBig: spotlightState?.ShowBadgeCount == 1, SpotlightInfoBadgeLabel: spotlightState?.ShowBadgeCount != 1 }">{{getBadgeLevelName(1)}}</div>
                        </div>

                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem2" *ngIf="spotlightState?.ShowBadgeCount != 1">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(2)" *ngIf="spotlightState?.ShowBadgeCount == 3 || spotlightState?.ShowBadgeCount == 6" />
                            <div class="SpotlightInfoBadgeLabel">{{getBadgeLevelName(2)}}</div>
                        </div>

                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem3" *ngIf="spotlightState?.ShowBadgeCount != 1">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(3)" *ngIf="spotlightState?.ShowBadgeCount == 3 || spotlightState?.ShowBadgeCount == 6" />
                            <div class="SpotlightInfoBadgeLabel">{{getBadgeLevelName(3)}}</div>
                        </div>
                    </div>

                    <div class="FlexRowNoWrap SpotlightInfoBadgeHolder" *ngIf="spotlightState?.ShowBadgeCount == 6">
                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem4">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(4)" />
                            <div class="SpotlightInfoBadgeLabel">{{getBadgeLevelName(4)}}</div>
                        </div>

                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem5">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(5)" />
                            <div class="SpotlightInfoBadgeLabel">{{getBadgeLevelName(5)}}</div>
                        </div>

                        <div class="SpotlightInfoBadge FlexColNoWrap badgeItem6">
                            <img class="SpotlightInfoBadgeIcon" [src]="getBadgeImage(6)" />
                            <div class="SpotlightInfoBadgeLabel">{{getBadgeLevelName(6)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="spotlightImageColumn">
            <div class="FlexColNoWrap spotlightImageHolder">
                <div [id]="'spotlightImg' + moduleKey" style="margin:auto; background-repeat:no-repeat"
                     [ngStyle]="{ 'background-image': getImage(), 'background-size': spotlightData?.useAvatar ? (imgWidth) + 'px' : '', 'background-position-y': spotlightData?.useAvatar ? '-50px' : '', 'margin-left': spotlightData?.useAvatar ? '-8vw' : '' }"></div>
            </div>
        </div>
    </div>
</div>
